import React, {useState, useEffect} from "react";
import { LoadingSpinner } from "../partials/LoadingSpinner";
// import { API_URL } from "../../../constants";
// import { GET_TOKEN } from "../../../helpers";
import "./Documentation.css";

export const Documentation = () => {
  // const [dataLoaded, setDataLoaded] = useState(false);
  // const [data, setData] = useState([]);

  const [dataLoaded] = useState(false);
  const [data] = useState([]);

  useEffect(() => {
    // setDataLoaded(false);

    // fetch(API_URL + 'X', {
    //   method: "get",
    //   headers: new Headers({
    //     Accept: "application/json",
    //     "Content-Type": "application/json",
    //     Authorization: "Bearer " + GET_TOKEN(),
    //   }),
    // })
    //   .then((response) => response.json())
    //   .then((response) => {
    //     setData(response);
    //   })
    //   .then(() => setData(true));

    // setDataLoaded(false);

  }, [data]);

  return (
    <div className="Documentation">
        {data.length > 0 && dataLoaded === true ? (
          <>
            Data loaded
          </>
        ) : dataLoaded ? (
          <div className="loading">No Data Found</div>
        ) : (
          <LoadingSpinner/>
        )}
    </div>
  );
};
